import * as SearchActionType from './constants';

const defaultParams = {
  searchKey: '',
  skip: 0,
  take: 100,
  totalRecord: 0,
  totalPage: 0
};

const initialState = {
  Homeowners: {
    items: [],
    params: defaultParams
  },
  WorkOrders: {
    items: [],
    params: defaultParams
  },
  RequestForServices: {
    items: [],
    params: defaultParams
  }
};

export default function GlobalSearchStore(state = initialState, action) {
  switch (action.type) {
    case SearchActionType.SEARCH_HOMEOWNER_SUCCESS: {
      return processSearchSuccess(state, action, 'Homeowners');
    }

    case SearchActionType.SEARCH_WORK_ORDERS_SUCCESS: {
      return processSearchSuccess(state, action, 'WorkOrders');
    }

    case SearchActionType.SEARCH_REQUEST_FOR_SERVICE_SUCCESS: {
      return processSearchSuccess(state, action, 'RequestForServices');
    }

    case SearchActionType.RESET_SEARCH_RESULT: {
      return {
        ...state,
        Homeowners: {
          items: [],
          params: defaultParams
        },
        WorkOrders: {
          items: [],
          params: defaultParams
        },
        RequestForServices: {
          items: [],
          params: defaultParams
        }
      };
    }

    default:
      return state;
  }
}

const processSearchSuccess = (state, action, key) => {
  const result = action.data;
  return {
    ...state,
    [key]: {
      items: result.data.items,
      params: {
        totalRecord: result.data.totalRecord,
        totalPage: result.data.totalPage,
        skip: result.params.skip,
        take: result.params.take,
        searchKey: result.params.searchKey,
        ProjectName: result.params.ProjectName || '',
        LotNumber: result.params.LotNumber || '',
        LotStreetAddress: result.params.LotStreetAddress || ''
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/Search/reducers.js